<template>
  <div>
    <b-checkbox v-model="isCopAccepted" :class="{'animate__animated': true, 'animate__shakeX': isError}">
      I agree to the <a href="#" @click="showCopModal(true)">community property disclosure</a>
    </b-checkbox>
    <portal to="global-modal-portal" v-if="isCopModalActive">
      <b-modal :active.sync="isCopModalActive" :width="640" scroll="keep" :has-modal-card="true" :canCancel="false">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">Community of Property Disclosure</p>
          </header>
          <section class="modal-card-body">
            <div class="columns">
              <div class="column has-text-left">
                <p>For a complete review of state level Community of Property laws please review the following online link <br><br>
                  <a href='https://www.investopedia.com/terms/c/communityproperty.asp' target='_blank'>Investopedia - Community of Property</a>
                  <br><br> By clicking 'Accept/Submit', you confirm to full community of property disclosure as required by state law.</p>
              </div>
            </div>
          </section>
          <footer class="modal-card-foot">
            <button class="button is-info" @click="showCopModal(false)">Accept</button>
          </footer>
        </div>
      </b-modal>
    </portal>
  </div>
</template>

<script>

export default {
  name: 'PropertyDisclosureControl',
  components: {
  },
  props: {
    currentCustomer: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isCopModalActive: false,
      instanceId: this.$uuid.v4(),
      isError: false
    }
  },
  computed: {
    // Bound directly to the prop so the checkbox cannot desync
    // when the parent reassigns currentCustomer.
    isCopAccepted: {
      get () {
        return this.currentCustomer ? !!this.currentCustomer.communityPropertyDisclosure : false
      },
      set (value) {
        if (this.currentCustomer) {
          this.currentCustomer.communityPropertyDisclosure = value
        }
      }
    }
  },
  methods: {
    showError: function () {
      this.$buefy.toast.open(
        {
          duration: 2500,
          message: 'You must accept the Community Property Disclosure terms to proceed',
          position: 'is-top',
          type: 'is-warning'
        })
      this.isError = true
      window.setTimeout(() => {
        this.isError = false
      }, 1000)
    },
    showCopModal: function (state) {
      if (state) {
        this.isCopModalActive = true
      } else {
        this.isCopModalActive = false
      }
    }
  },
  mounted: function () {
  }
}

</script>

<style scoped>
  .modal-card-head, .modal-card-foot {
    padding: 20px !important
  }

  .modal-card-body {
    max-height: 500px !important;
    min-height: 500px !important;
    height: 500px !important;
  }
</style>
